import { ButtonProps, Typography } from '@mui/material';
import { MainNavigationRedirectLink } from '@/components/main/navigation/MainNavigationRedirectLink';
import { Path, PathMatch, useMatch, useResolvedPath } from 'react-router-dom';
import { RouteLink } from '@/components/common/RouteLink';
import { Theme } from '@mui/material/styles';
import React, { FC, Fragment, ReactElement } from 'react';

export interface MainNavigationItemProps extends ButtonProps {
  to: string;
  label: string;
  value?: number;
  total?: number;
  size?: 'small' | 'medium';
  activeOnlyWhenExact?: boolean;
  isRedirect?: boolean;
}

export const MainNavigationItem: FC<MainNavigationItemProps> = (props: MainNavigationItemProps): ReactElement => {
  const { to, label, activeOnlyWhenExact, isRedirect } = props;

  const resolvedPath: Path = useResolvedPath(to);

  const match: PathMatch<string> | null = useMatch({
    path: resolvedPath.pathname,
    end: activeOnlyWhenExact ?? false,
  });

  const handleRedirect = (): void => {
    window.location.href = to;
  };

  return (
    <Fragment>
      {isRedirect ? (
        <MainNavigationRedirectLink href={to}>
          <Typography
            variant={'h4'}
            fontSize={'14px'}
            lineHeight={'14px'}
            onClick={handleRedirect}
            sx={{ color: (theme: Theme) => (match ? theme.colors.grayText : theme.colors.primary) }}>
            {label}
          </Typography>
        </MainNavigationRedirectLink>
      ) : (
        <RouteLink to={to}>
          <Typography
            variant={'h4'}
            fontSize={'14px'}
            lineHeight={'14px'}
            sx={{ color: (theme: Theme) => (match ? theme.colors.grayText : theme.colors.primary) }}>
            {label}
          </Typography>
        </RouteLink>
      )}
    </Fragment>
  );
};
